import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function BuyoffReportList(props) {
  const Config = {
    purchase: {
      apiPath: '/b2bMaterialReport/list',
      enumMainKey: '',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/supplier/buyoff-report/detail',
      searchBarPlaceholder: '物料编码/名称/规格',
      tabs: ['全部', '待评分', '待回复', '待审核'],
      countApi: '/b2bMaterialReport/count',
      arrEnumField: [
        {
          mainKey: 'B02_Material_Report_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Material_Report_Result',
          subKey: 'materialReportResult',
          value: 'materialReportResultName'
        }
      ],
      countTransform: (data, self) => {
        let { 2: a, 1: b, 4: c } = data;
        setCount([undefined, a, b, c]);
      },
      tabConfig: [
        undefined, //全部
        2, // 待评分
        1, //待回复
        4 //待审核
      ]
    },
    sale: {
      apiPath: '/b2bCustomerMaterialReport/list',
      enumMainKey: '',
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/customer/buyoff-report/detail',
      searchBarPlaceholder: '物料编码/名称/规格',
      tabs: ['全部', '待评分', '待回复', '待审核'],
      countApi: '/b2bCustomerMaterialReport/count',
      arrEnumField: [
        {
          mainKey: 'B02_Material_Report_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Material_Report_Result',
          subKey: 'materialReportResult',
          value: 'materialReportResultName'
        }
      ],
      countTransform: (data, self) => {
        let { 2: a, 1: b, 4: c } = data;
        setCount([undefined, a, b, c]);
      },
      tabConfig: [
        undefined, //全部
        2, // 待评分
        1, //待回复
        4 //待审核
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  self.beforeSearch = function () {
    self.searchQueries = {
      status: config.tabConfig[currentTab]
    };
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.materialReportXkNo}`}
                      key={item.id}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.materialReportXkNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass(
                                'ItemReport',
                                item.status
                              )
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        <li>
                          <label>物料</label>
                          <div>
                            {item.productCode}，{item.productName}
                          </div>
                        </li>
                        <li>
                          <label>物料分类</label>
                          <div>{item.materCategoryTypeName}</div>
                        </li>
                        {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.customerPrintName}({item.customerPrintCode})
                            </div>
                          </li>
                        )}
                        {item.materialReportResultName && (
                          <li>
                            <label>评审结果</label>
                            <div
                              className={
                                'u-sign ' +
                                CommonFns.getStatusClass(
                                  'reportResult',
                                  item.materialReportResult
                                )
                              }
                            >
                              {item.materialReportResultName}
                            </div>
                          </li>
                        )}
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

BuyoffReportList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(BuyoffReportList);
